'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { usePricingCalculatorContext } from '@/modules/service-purchase/providers/pricing-calculator-provider';
import { useHoveredTier } from '@/modules/service-purchase/providers/service-purchase-store-provider';
import type { FeatureValue } from '@/modules/service-purchase/types';
import { ServiceCatalogCell } from '../service-catalog-cell';
export interface MetricRowProps {
  label: string;
  values: Record<string, FeatureValue>;
  isLast?: boolean;
  isOneTime?: boolean;
}
function MetricRow(t0) {
  const $ = _c(58);
  const {
    label,
    values,
    isLast,
    isOneTime
  } = t0;
  const {
    activePlan,
    tierNames
  } = usePricingCalculatorContext();
  const hoveredPlan = useHoveredTier();
  const lastTierName = tierNames[tierNames.length - 1];
  let t1;
  if ($[0] !== isOneTime || $[1] !== values) {
    t1 = isOneTime ? Object.values(values).find(_temp) ?? null : null;
    $[0] = isOneTime;
    $[1] = values;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const oneTimeValue = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("items-center", "grid grid-cols-2 lg:grid-cols-(--grid-cols-lg) xl:grid-cols-(--grid-cols-xl)");
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `4fr repeat(${tierNames.length}, minmax(144px, 1fr))`;
  const t4 = `4fr repeat(${tierNames.length}, minmax(220px, 1fr))`;
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = {
      "--grid-cols-lg": t3,
      "--grid-cols-xl": t4
    };
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = t5 as React.CSSProperties;
  const t7 = isLast && "border-input border-b";
  let t8;
  if ($[7] !== t7) {
    t8 = cn("bg-background relative flex h-full min-h-10 items-center gap-1.5 pr-4 pl-10 lg:gap-2 lg:pr-6 lg:pl-12", "sticky left-0 z-10 lg:relative", t7);
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = isLast ? "h-1/2 rounded-bl-md" : "h-full";
  let t10;
  if ($[9] !== t9) {
    t10 = cn("bg-border absolute top-0 left-6 w-px lg:left-8", t9);
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== t10) {
    t11 = <div className={t10} />;
    $[11] = t10;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  const t12 = isLast && "rounded-bl-md";
  let t13;
  if ($[13] !== t12) {
    t13 = cn("bg-border absolute top-1/2 left-6 h-px w-4 -translate-y-px lg:left-8", t12);
    $[13] = t12;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== t13) {
    t14 = <div className={t13} />;
    $[15] = t13;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <span className="bg-border z-10 size-1.5 shrink-0 rounded-full" />;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  let t16;
  if ($[18] !== label) {
    t16 = <span className="text-foreground/70 text-xs lg:text-sm">{label}</span>;
    $[18] = label;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] !== t11 || $[21] !== t14 || $[22] !== t16 || $[23] !== t8) {
    t17 = <div className={t8}>{t11}{t14}{t15}{t16}</div>;
    $[20] = t11;
    $[21] = t14;
    $[22] = t16;
    $[23] = t8;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  const t18 = isLast && "border-input border-b";
  const t19 = !!activePlan && "bg-primary/10";
  let t20;
  if ($[25] !== t18 || $[26] !== t19) {
    t20 = cn("flex h-full min-h-10 min-w-0 items-center justify-center px-4 transition-colors lg:hidden", t18, t19);
    $[25] = t18;
    $[26] = t19;
    $[27] = t20;
  } else {
    t20 = $[27];
  }
  let t21;
  if ($[28] !== activePlan || $[29] !== isOneTime || $[30] !== oneTimeValue || $[31] !== values) {
    t21 = isOneTime ? oneTimeValue ? <span className="text-primary min-w-0 truncate text-xs font-bold uppercase">{oneTimeValue}</span> : null : <ServiceCatalogCell value={values[activePlan ?? ""]} isActive={!!activePlan} />;
    $[28] = activePlan;
    $[29] = isOneTime;
    $[30] = oneTimeValue;
    $[31] = values;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  let t22;
  if ($[33] !== t20 || $[34] !== t21) {
    t22 = <div className={t20}>{t21}</div>;
    $[33] = t20;
    $[34] = t21;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== activePlan || $[37] !== hoveredPlan || $[38] !== isLast || $[39] !== isOneTime || $[40] !== lastTierName || $[41] !== oneTimeValue || $[42] !== tierNames || $[43] !== values) {
    let t24;
    if ($[45] !== activePlan || $[46] !== hoveredPlan || $[47] !== isLast || $[48] !== isOneTime || $[49] !== lastTierName || $[50] !== oneTimeValue || $[51] !== values) {
      t24 = plan => <div key={plan} className={cn("relative hidden min-h-full min-w-0 items-center px-6 transition-colors lg:flex", isOneTime ? "" : "justify-center", isLast && "border-input border-b", activePlan === plan && "bg-primary/10", hoveredPlan === plan && activePlan !== plan && "bg-accent/80")}>{isOneTime ? plan === lastTierName && oneTimeValue ? <span className="text-primary absolute right-6 min-w-0 text-xs font-bold whitespace-nowrap uppercase">{oneTimeValue}</span> : null : <ServiceCatalogCell value={values[plan]} isActive={activePlan === plan} />}</div>;
      $[45] = activePlan;
      $[46] = hoveredPlan;
      $[47] = isLast;
      $[48] = isOneTime;
      $[49] = lastTierName;
      $[50] = oneTimeValue;
      $[51] = values;
      $[52] = t24;
    } else {
      t24 = $[52];
    }
    t23 = tierNames.map(t24);
    $[36] = activePlan;
    $[37] = hoveredPlan;
    $[38] = isLast;
    $[39] = isOneTime;
    $[40] = lastTierName;
    $[41] = oneTimeValue;
    $[42] = tierNames;
    $[43] = values;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[53] !== t17 || $[54] !== t22 || $[55] !== t23 || $[56] !== t6) {
    t24 = <div className={t2} style={t6}>{t17}{t22}{t23}</div>;
    $[53] = t17;
    $[54] = t22;
    $[55] = t23;
    $[56] = t6;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  return t24;
}
function _temp(v) {
  return typeof v === "string";
}
export { MetricRow };